import axios from '@/utils/axios';

// 订单列表
export function OrderList(orderStatus, page, limit) {
    return axios({
        url: '/order/list',
        method: 'get',
        params: { orderStatus, page, limit },
    });
}

// 订单详情
export function OrderInfo(orderId) {
    return axios({
        url: '/order',
        method: 'get',
        params: { orderId },
    });
}

//下单
export function OrderSubmit(goodsIdList, goodsNumberList, unitPriceList, remark, addressId, freed, source, code, selectedVoucherListStr) {
    return axios({
        url: '/order/submit',
        method: 'post',
        params: { goodsIdList: goodsIdList, goodsNumberList: goodsNumberList, unitPriceList: unitPriceList, remark, addressId, freed, source, code, selectedVoucherListStr: selectedVoucherListStr ? encodeURIComponent(selectedVoucherListStr) : undefined },
    });
}

// 取消订单
export function OrderCancel(orderId, cancelRemark) {
    return axios({
        url: '/order/cancel',
        method: 'post',
        params: { orderId, cancelRemark },
    });
}

// 确认收货
export function OrderConfirm(orderId) {
    return axios({
        url: '/order/confirm',
        method: 'post',
        params: { orderId },
    });
}

// 订单数量查询
export function OrderTotal() {
    return axios({
        url: '/order/total',
        method: 'get',
        params: { },
    });
}

//获取非配送日
export function OrderDeliver() {
    return axios({
        url: '/ladysHoliday/check',
        method: 'get',
        params: {}
    });
}

export function CheckPresale() {
    return axios({
        url: 'order/check-presale',
        method: 'get',
        params: {},
    })
}


